import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    submit: 'Back to the help center',
    subtitle:
      'You will receive a reply from your Shine team by e-mail within the next few hours.',
    title: 'Message sent successfully!',
  },
  fr: {
    submit: 'Revenir au centre d’aide',
    subtitle:
      'Vous recevrez une réponse de votre équipe Shine par e-mail dans les prochaines heures.',
    title: 'Message envoyé avec succès !',
  },
} as const);

export default locales;
